"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-input", {
    staticClass: "filter-item",
    attrs: {
      placeholder: _vm.$t("product.name"),
      "prefix-icon": "el-icon-search"
    },
    nativeOn: {
      keyup: function ($event) {
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery["product.name"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "product.name", $$v);
      },
      expression: "listQuery['product.name']"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: "Category",
      clearable: "",
      filterable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["category.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "category.id", $$v);
      },
      expression: "listQuery['category.id']"
    }
  }, _vm._l(_vm.categoryList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Select License TC",
      size: "small"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["licenseTc.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "licenseTc.id", $$v);
      },
      expression: "listQuery['licenseTc.id']"
    }
  }, _vm._l(_vm.licenseTcList, function (tc) {
    return _c("el-option", {
      key: tc.id,
      attrs: {
        label: tc.name,
        value: tc.id
      }
    });
  }), 1)], 1), _vm.groupedProducts.length ? _c("div", {
    staticClass: "product-grid"
  }, [_c("div", {
    ref: "productScroll",
    staticClass: "product-scroll"
  }, _vm._l(_vm.groupedProducts, function (group) {
    var _group$product$produc, _group$product, _group$variations$;
    return _c("div", {
      key: group.product.id,
      staticClass: "product-card"
    }, [_c("div", {
      staticClass: "product-image-wrap"
    }, [_c("el-image", {
      staticClass: "product-image",
      attrs: {
        src: ((_group$product$produc = group.product.productsImage[0]) === null || _group$product$produc === void 0 ? void 0 : _group$product$produc.image) + "-md" || "...",
        fit: "contain"
      }
    }, [_c("div", {
      staticClass: "image-placeholder",
      attrs: {
        slot: "error"
      },
      slot: "error"
    }, [_c("i", {
      staticClass: "el-icon-picture-outline"
    })])])], 1), _c("div", {
      staticClass: "product-body"
    }, [_c("div", {
      staticClass: "product-name"
    }, [_vm._v(" " + _vm._s(((_group$product = group.product) === null || _group$product === void 0 ? void 0 : _group$product.name) || ((_group$variations$ = group.variations[0]) === null || _group$variations$ === void 0 ? void 0 : _group$variations$.name) || "Unnamed product") + " ")]), _c("div", {
      staticClass: "variation-list"
    }, _vm._l(group.variations, function (variation) {
      return _c("div", {
        key: variation.id,
        staticClass: "variation-row",
        class: {
          "variation-disabled": _vm.isVariationDisabled(variation),
          "variation-already-added": _vm.isAlreadyAdded(variation)
        }
      }, [_c("el-checkbox", {
        attrs: {
          label: variation,
          disabled: _vm.isVariationDisabled(variation)
        },
        model: {
          value: _vm.selectedVariations,
          callback: function ($$v) {
            _vm.selectedVariations = $$v;
          },
          expression: "selectedVariations"
        }
      }, [_c("div", {
        staticClass: "variation-info"
      }, [_c("div", {
        staticClass: "variation-left"
      }, [_c("span", {
        staticClass: "variation-name"
      }, [_vm._v(" " + _vm._s(_vm.getModelCode(variation) || _vm.formatVariationLabel(variation)) + " "), _vm.getLicenseTcName(variation) ? _c("span", {
        staticClass: "variation-license-text"
      }, [_vm._v(" - " + _vm._s(_vm.getLicenseTcName(variation)) + " ")]) : _vm._e()]), _vm.isAlreadyAdded(variation) ? _c("span", {
        staticClass: "variation-added-badge"
      }, [_vm._v("Already added")]) : _vm._e()]), _c("span", {
        staticClass: "variation-price"
      }, [_c("i", {
        staticClass: "el-icon-price-tag"
      }), _vm._v(" " + _vm._s(_vm.formatPrice(variation)) + " ")])])])], 1);
    }), 0)])]);
  }), 0), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getProductList
    }
  }), _c("div", {
    staticClass: "submit-row"
  }, [_c("span", {
    staticClass: "selection-count"
  }, [_vm._v(" " + _vm._s(_vm.selectedVariations.length) + " variation(s) selected ")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      icon: "el-icon-plus",
      disabled: !_vm.selectedVariations.length
    },
    on: {
      click: _vm.submitSelection
    }
  }, [_vm._v(" Add Selected ")])], 1)], 1) : _c("div", {
    staticClass: "empty-state"
  }, [_c("i", {
    staticClass: "el-icon-box"
  }), _c("p", [_vm._v("No products available for the selected filter")])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;